const SET_MERCHANT_ORDER = 'EXPLORE/SET_MERCHANT_ORDER'
const SET_MERCHANT_SHOPS = 'EXPLORE/SET_MERCHANT_SHOPS'
const SET_MERCHANT_DINE = 'EXPLORE/SET_MERCHANT_DINE'
const SET_MERCHANT_UNWIND = 'EXPLORE/SET_MERCHANT_UNWIND'
const SET_MERCHANT_POPULAR = 'EXPLORE/SET_MERCHANT_POPULAR'
const SET_MERCHANT_MODAL_DATA = 'EXPLORE/SET_MERCHANT_MODAL_DATA'
const SET_MERCHANT_MODAL_STATUS = 'EXPLORE/SET_MERCHANT_MODAL_STATUS'
const SET_DISPLAY_MALL_WELCOME = 'EXPLORE/SET_DISPLAY_MALL_WELCOME'
const SET_DISPLAY_APP_BANNER = 'EXPLORE/SET_DISPLAY_APP_BANNER'
const SET_DISPLAY_APP_MODAL = 'EXPLORE/SET_DISPLAY_APP_MODAL'
const SET_SELECTED_MALL_SLUG = 'EXPLORE/SET_SELECTED_MALL_SLUG'
const SET_ZING_PARTNERS = 'EXPLORE/SET_ZING_PARTNERS'

export {
  SET_MERCHANT_ORDER,
  SET_MERCHANT_SHOPS,
  SET_MERCHANT_DINE,
  SET_MERCHANT_UNWIND,
  SET_MERCHANT_POPULAR,
  SET_MERCHANT_MODAL_DATA,
  SET_MERCHANT_MODAL_STATUS,
  SET_DISPLAY_MALL_WELCOME,
  SET_DISPLAY_APP_BANNER,
  SET_DISPLAY_APP_MODAL,
  SET_SELECTED_MALL_SLUG,
  SET_ZING_PARTNERS,
}
